/**
 * CXProgram is a customer experience variations which may have unique messaging, configuration, or other features.
 * For example, exports, smile or b2b.
 */
class CXProgram {
    constructor(programs) {
        this._programs = [...programs];
        this._programs.sort();
    }
    /**
     * Construct a CXProgram instance with the list of programs
     */
    static of(programs) {
        return new CXProgram(programs);
    }
    /**
     * Check if the CXProgram contains the given program
     */
    has(program) {
        return this._programs.includes(program);
    }
    /**
     * Check if the CXProgram is empty
     */
    isEmpty() {
        return this._programs.length == 0;
    }
    toString() {
        const programStr = this._programs.join(CXProgram.DELIMITER);
        return CXProgram.OPENING_CHAR + programStr + CXProgram.CLOSING_CHAR;
    }
    /**
     * Construct CXTuple instance from qualified string of form "[program1,program2]"
     */
    static fromString(fullyQualifiedString) {
        if (!fullyQualifiedString.startsWith(CXProgram.OPENING_CHAR)
            || !fullyQualifiedString.endsWith(CXProgram.CLOSING_CHAR)) {
            throw new Error(`Invalid fully qualified CXProgram: ${fullyQualifiedString}. Valid example: [exports].`);
        }
        const programStr = fullyQualifiedString.substring(1, fullyQualifiedString.length - 1).trim();
        if (programStr.length == 0) {
            return CXProgram.EMPTY;
        }
        const programs = [];
        for (const program of programStr.split(CXProgram.DELIMITER)) {
            const programEnum = program.trim().toLowerCase();
            if (!Object.values(Program).includes(programEnum)) {
                throw new Error(`Unrecognized program ${program}`);
            }
            programs.push(programEnum);
        }
        return new CXProgram(programs);
    }
    equals(o) {
        if (!o) {
            return false;
        }
        // can compare the string directly as we sort the program in constructor.
        return this.toString() === o.toString();
    }
}
/**
 * Reserved CXProgram instance that contains empty program list.
 */
CXProgram.EMPTY = CXProgram.of([]);
CXProgram.DELIMITER = ',';
CXProgram.OPENING_CHAR = '[';
CXProgram.CLOSING_CHAR = ']';
/**
 * Program that represents the customers' shopping mode.
 */
var Program;
(function (Program) {
    Program["EXPORTS"] = "exports";
    Program["B2B"] = "b2b";
})(Program || (Program = {}));
export { CXProgram, Program };
//# sourceMappingURL=data:application/json;base64,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